<template>
  <div>
    <div class="content-header row">
      <div class="content-header-left col-12 mb-2 mt-1">
        <div class="row breadcrumbs-top">
          <div class="col-12">
            <div class="card">
              <div class="card-content">
                <form action="">
                  <div class="form-group row ml-2 mt-3 mr-2">
                    <div class="col-6">
                      <label for="enterprise-name" class="textStyling"> {{
                          $t('enterprise_profile_enterprise_name')
                        }} </label>
                      <input type="text" class="form-control height-50" disabled v-model="enterpriseName"/>
                    </div>
                    <div class="col-6">
                      <label for="enterprise-account-number" class="textStyling">
                        {{ $t('enterprise_profile_enterprise_account_number') }} </label>
                      <input type="text" class="form-control height-50" disabled v-model="enterpriseAccountNumber"/>
                    </div>
                  </div>
                </form>
                <div class="row">
                  <div class="col-12 divStyling my-2">
                   <span class=" buttonSpan">
                      <router-link :to="{name:'EnterpriseProfile', params:{ent: enterpriseId }}">
                      <button type="button" class="btn  buttonStyle ml-1"
                              :class="this.$route.name==='EnterpriseProfile' ? 'btn-primary' : 'btn-light-secondary '">
                        <em class="bx bx-check d-block d-sm-none"></em>
                        <span class="fontStyle"
                              :class="this.$route.name==='EnterpriseProfile' ? 'd-sm-block' : 'btn-light-secondary-font'"> {{
                            $t('enterprise_account_profile_button')
                          }}</span>
                      </button>
                      </router-link>
                    </span>
                    <span class=" buttonSpan">
                      <router-link :to="{name:'EnterpriseUsers', params:{ent: enterpriseId }}">
                      <button type="button" class="btn  buttonStyle ml-4"
                              :class="this.$route.name==='EnterpriseUsers' ? 'btn-primary' : 'btn-light-secondary'">
                        <em class="bx bx-check d-block d-sm-none"></em>
                        <span class="fontStyle"
                              :class="this.$route.name==='EnterpriseUsers' ? 'd-sm-block' : 'btn-light-secondary-font'"> {{
                            $t('enterprise_account_enterprise_users_button')
                          }}</span>
                      </button>
                      </router-link>
                    </span>
                    <span class=" buttonSpan">
                      <router-link :to="{name:'AgreementTerms', params:{ent: enterpriseId }}">
                      <button type="button" class="btn  buttonStyle ml-4"
                              :class="this.$route.name==='AgreementTerms' ? 'btn-primary' : 'btn-light-secondary'">
                        <em class="bx bx-check d-block d-sm-none"></em>
                        <span class="fontStyle"
                              :class="this.$route.name==='AgreementTerms' ? 'd-sm-block' : 'btn-light-secondary-font'"> {{
                            $t('enterprise_account_enterprise_agreement_terms_button')
                          }}</span>
                      </button>
                      </router-link>
                    </span>
                    <span class=" buttonSpan">
                      <router-link :to="{name:'SubscriptionsLicenses', params:{ent: enterpriseId }}">
                      <button type="button" class="btn  buttonStyle ml-4"
                              :class="this.$route.name==='SubscriptionsLicenses' ? 'btn-primary' : 'btn-light-secondary'">
                        <em class="bx bx-check d-block d-sm-none"></em>
                        <span class="fontStyle"
                              :class="this.$route.name==='SubscriptionsLicenses' ? 'd-sm-block' : 'btn-light-secondary-font'"> {{
                            $t('enterprise_account_enterprise_subscriptions_licenses_button')
                          }}</span>
                      </button>
                      </router-link>
                    </span>
                  </div>
                </div>
              </div>
              <router-view/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import EnterpriseProfile from '@/views/Enterprise-Profile-Page/EnterpriseProfile';
import EnterpriseUsers from '@/views/Enterprise-Users/EnterpriseUsers';
import AgreementTerms from '@/views/Enterprise-Agreement-Terms/AgreementTerms';
import SubscriptionsLicenses from '@/views/Enterprise-Subscriptions-Licenses/SubscriptionsLicenses';

export default {
  name: "EnterpriseProfilePage",
  data() {
    return {
      enterpriseName: "",
      enterpriseAccountNumber: '',
      enterpriseId: ''
    }
  },
  components: {
    EnterpriseProfile,
    EnterpriseUsers,
    AgreementTerms,
    SubscriptionsLicenses
  },
  methods: {
    getEnterpriseId() {
      let self = this;
      let userData = JSON.parse(window.localStorage.getItem('user'))
      console.log("type of user", typeof (userData), userData.enterpriseAccountId)
      self.enterpriseId = userData.enterpriseAccountId;
      console.log("local-storage-enterprise-id", self.enterpriseId);
      this.getEnterpriseData()
      console.log("parammaaaaaaaaa", this.$route.path)
      if (this.$route.path == '/enterprise-account') {
        this.redirect(self.enterpriseId)
      }
    },
    getEnterpriseData() {
      let self = this;
      this.$apiCall.get(`v1/enterpriseaccount/${self.enterpriseId}`).then((response) => {
        console.log("response-----", response)
        let resp = response.data;
        self.enterpriseAccountNumber = resp.accountNumber;
        self.enterpriseName = resp.officialBusinessName;

      })
    },
    redirect(enterpriseId) {
      this.$router.push({name: 'EnterpriseProfile', params: {ent: enterpriseId}});
    },

  },
  created() {
    this.getEnterpriseId()
  }
}
</script>
<style>
.textStyling {
  color: #4A4949;
  border-radius: 5px;
}

.divStyling {
  margin-left: .5rem;
}

.buttonStyle {
  border-radius: 6px;
  height: 3rem;
}

.btn-light-secondary-font {
  color: black !important;
}

.btn-light-secondary {
  background-color: #a9a6a6;
  color: #a9a6a6;
}
</style>


